import { useNavigate } from "react-router-dom";
import { Page } from "../Components/page/Page";
import { useTreasuryClient } from "../lib/client";
import { Labelled } from "../Components";
import Title from "../Components/page/Title";
import { ButtonCancel, ButtonOk } from "../Components/buttons";
import { useMutation } from "@tanstack/react-query";
import { useState } from "react";
import { validateTwinUrl } from "../lib/validation";
import { TwinPersona1 } from "../Components/TwinPersona";
import { useBalance } from "../lib/balance";
import { useTwinPersona } from "../Components/Address";

export default function SendTDN() {
  const navigate = useNavigate();

  const treasury = useTreasuryClient();
  if (!treasury.isPurchaser) {
    navigate("/home");
  }

  const { data: dq } = useBalance(treasury.tdnHash);

  const { mutate: createPurchase } = useMutation({
    mutationFn: async function submitTdnPurchase(purchase) {
      return await treasury.createPurchase(purchase)
    },
    onSuccess: function createPurchaseSuccessFn(data) {
      navigate(`/purchase/${data.id}`);
    },
    onError: function createPurchaseErrorFn(error) {
      console.error(error);
    }
  })


  function getTwinDetails(e) {
    e.preventDefault();

    if (validTwinUrl.value) {
      console.log("getting twin details for", validTwinUrl.value)
    } else {
      console.log("Invalid twin url; will skip persona lookup")
    }
  }

  function submitTransfer(e) {
    e.preventDefault();
    const formData = new FormData(e.target);
    const purchase = {
      destination: validTwinUrl.value,
      expectedValue: (transferAmountInput),
      paidValue: Number(formData.get("amount-paid")),
      paidValueUnits: formData.get("currency"),
      paymentReceipt: JSON.stringify({
        type: formData.get("receipt-type"),
        notes: formData.get("receipt-details")
      })
    };
    createPurchase(purchase);
  }

  const [validTwinUrl, setValidTwinUrl] = useState({});

  function validateUrl(e) {
    let inputUrl = e.target.value;

    setValidTwinUrl({});
    if (!inputUrl) return ;

    let result = validateTwinUrl(inputUrl);
    if (result == null) {
      setValidTwinUrl({ value: inputUrl });
    } else {
      setValidTwinUrl(result);
    }
  }

  const [ transferAmountInput, setTransferAmountInput ] = useState(0);
  const { info, persona } = useTwinPersona(validTwinUrl.value);

  return <Page>
    <div className="flex flex-row justify-center w-full mt-10">
      <div className="flex flex-col w-full lg:w-1/2 md:w-2/3 sm:w-full gap-3">

        <Title>CREATE PURCHASE RECORD AND SEND NOTES</Title>

        <form className="flex flex-col gap-3" onSubmit={submitTransfer}>
          <Labelled label={`Destination URL`}>
            <input
              name="twin-url"
              required
              type="text"
              onChange={validateUrl}
              onBlur={getTwinDetails}
              data-invalid={!validTwinUrl.value && !!validTwinUrl.error}
              placeholder="https://...."
              className="w-full px-2 py-1 border rounded disabled:bg-zinc-100 disabled:text-zinc-400 data-[invalid=true]:text-error" />
            <p className="my-1 ml-2 text-xs text-error" hidden={!validTwinUrl.error}>❌ {validTwinUrl.error} </p>
            <div className="my-1" hidden={!validTwinUrl.value}>
              {/* <TwinPersona twinUrl={validTwinUrl.value}/> */}
              <TwinPersona1 twinUrl={validTwinUrl.value} info={info} persona={persona}/>
            </div>
          </Labelled>
          <div className="flex flex-row justify-stretch gap-2">
            <Labelled label="Paid amount" className="w-full">
              <input
                name="amount-paid"
                type="number"
                max={10_000}
                min={5}
                step={0.001}
                required
                onChange={(e) => setTransferAmountInput(Number(e.target.value)*treasury.config.purchase.dq_purchase_price)}
                placeholder="Paid amount 5 to 10000"
                className="w-full px-2 py-1 border rounded disabled:bg-zinc-100 disabled:text-zinc-400 invalid:text-error"
              />
            </Labelled>

            <Labelled label="Currency">
              <select
                name="currency"
                className="w-fit px-2 py-[0.37rem] border rounded disabled:bg-zinc-100 disabled:text-zinc-400" >
                <option key={treasury.currency}>{treasury.currency}</option>
              </select>
            </Labelled>

          </div>
          <Labelled label={`Transfer amount (${treasury.tdnMoniker})`}>
            {/* this should be a calculated field */}
            <span className="w-full px-2 py-1 border rounded">
              {transferAmountInput.toFixed(dq?.displayPrecision)}
            </span>
          </Labelled>
          <Labelled label="Type of receipt">
            <input
              name="receipt-type"
              required
              type="text"
              placeholder="Wire, ACH, etc..."
              className="w-full px-2 py-1 border rounded disabled:bg-zinc-100 disabled:text-zinc-400 invalid:text-error" />
          </Labelled>
          <Labelled label="Details">
            <textarea
              name="receipt-details"
              required
              placeholder="Enter receipt details"
              className="w-full px-2 py-1 border rounded disabled:bg-zinc-100 disabled:text-zinc-400 invalid:text-error" />
          </Labelled>
          <div className="flex flex-row w-full justify-between mt-3">
            <ButtonCancel onClick={() => navigate(-1)} >Back</ButtonCancel>
            <ButtonOk disabled={!validTwinUrl.value || !info.data } type="submit">Send {treasury.tdnMoniker}</ButtonOk>
          </div>
        </form>
      </div>
    </div>
  </Page>
}